// WhatsApp Configuration
export const whatsappConfig = {
  // Replace with your actual WhatsApp number (include country code, no + sign)
  phoneNumber: "+971501195171", // Example UAE number
  
  // Default message that will be sent when user clicks WhatsApp
  defaultMessage: "Hi! I'm interested in your photography services. Can you tell me more about your packages?",
  
  // Business hours for display (optional)
  businessHours: {
    enabled: true,
    timezone: "Asia/Dubai",
    hours: "9:00 AM - 6:00 PM",
    days: "Monday - Friday"
  },
  
  // Chat widget settings
  widget: {
    // Delay before showing the button (in milliseconds)
    showDelay: 2000,
    
    // Position of the button
    position: {
      bottom: "24px", // 6 * 4px = 24px (Tailwind spacing)
      right: "24px"  // 6 * 4px = 24px (Tailwind spacing)
    },
    
    // Colors
    colors: {
      primary: "#25D366", // WhatsApp green
      hover: "#128C7E",   // Darker green for hover
      text: "#FFFFFF"     // White text
    }
  }
};

export default whatsappConfig;
